import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow} from 'material-ui/Table';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import CircularProgress from 'material-ui/CircularProgress';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Menu from 'material-ui/Menu';
import Popover from 'material-ui/Popover';
import AutoComplete from 'material-ui/AutoComplete';
import BaseService from '../../service/baseservice';
import ContactRow from './ContactRow';
import ContactNewRow from './ContactNewRow';
import UserSelectField from '../shared/UserSelectField';
import Checkbox from 'material-ui/Checkbox';

import { logosUrl } from '../../config/constants'

var CompanyService = require('../../service/companies');
var Auth = require('../../service/auth');

/**
 * A modal dialog can only be closed by selecting one of the actions.
 */
export default class CompanyEditDialog extends Component {

  emptyCompany() {
    return {
          marketingName: "",
          officialName: "",
          streetAddress: "",
          companyContacts: [],
          decisionHistory: []
        };
  }

  state = {
    hasUnsavedChanges: false,
    editedOfficialNameOnce: false,
    nameErrorText: undefined,
    categoryErrorText: undefined,
    municipalityErrorText: undefined,
    valueErrorText: undefined,
    fileUploadErrorText: undefined,
    isNew: true,
    saving: false,
    company: this.emptyCompany(),
    addingNewContact: false,
    dataUpdated: null,
    selectedDecision: undefined,
    decisionDialogOpen: false,
    deleteDialogOpen: false
  };

  dataUpdated(data) {
    this.setState({dataUpdated: new Date()});
  }

  componentDidMount() {
    BaseService.addListener(this.dataUpdated.bind(this));
  }

  componentWillReceiveProps(newProps) {
    let disableIsAffa = newProps.company.isAffa || false

    this.setState({company: newProps.company,
        saving: false,
        editedOfficialNameOnce: false,
        disableIsAffa,
        isNew: (!newProps.company || newProps.company._id === undefined)});
  }

  handleFormEdit = (state) => {
    state.hasUnsavedChanges = true;
    return state;
  }

  editValue = (event, key) => {
    var state = this.state;
    state.company[key] = event.target.value;
    state = this.handleFormEdit(state);
    this.setState(state);
  }

  editContinuousContract(request, isChecked) {
    this.editBoolValue(request, !isChecked, "isContinuousContract");
  }

  editBoolValue(request, isChecked, property) {
    var state = this.state;
    state.company[property] = isChecked;
    state = this.handleFormEdit(state);
    this.setState(state);
  }

  handleValueEdit = (event) => {
    this.editValue(event, "contractValue");
    var state = this.state;

    if (!this.isValidValue()) {
      state.valueErrorText = "Syötä positiivinen numero";
    } else {
      state.valueErrorText = undefined;
    }
    this.setState(state);
  }

  handleOfficialNameEdit = (event) => {
    var state = this.state;
    state.company.officialName = event.target.value;
    state.editedOfficialNameOnce = true;
    state.nameErrorText = undefined;
    state = this.handleFormEdit(state);
    this.setState(state);
  }

  handleMarketingNameEdit = (event) => {
    var state = this.state;
    state.company.marketingName = event.target.value;
    state = this.handleFormEdit(state);
    this.setState(state);
  }

  handleStreetAddressEdit = (event) => {
    var state = this.state;
    state.company.streetAddress = event.target.value;
    state = this.handleFormEdit(state);
    this.setState(state);
  }

  handleSellerChanged = (selectedSeller) => {
    var state = this.state;
    state.company.seller = selectedSeller;

    state = this.handleFormEdit(state);
    this.setState(state);
  }

  handleIndustryChanged = (request, index) => {
    var state = this.state;
    state.company.industry = BaseService.fetchedData.industries[index];
    state.company.mainCategory = null;
    state.categoryErrorText = undefined;
    state = this.handleFormEdit(state);
    this.setState(state);
  }

  handleMunicipalityChanged = (request, index) => {
    var state = this.state;
    state.company.municipality = BaseService.fetchedData.municipalities[index].name;
    state.municipalityErrorText = undefined;
    state = this.handleFormEdit(state);
    this.setState(state);
  }

  handleCityChanged = (request, index) => {
    var state = this.state;
    state.company.city = BaseService.fetchedData.cities[index];
    state = this.handleFormEdit(state);
    this.setState(state);
  }

  openDecisionMenu = (event) => {
    this.setState({decisionDialogOpen: true});
  }

  cancelDecisionMenu = () => {
    this.setState({decisionDialogOpen: false});
  }

  makeDecision = (type) => {
    this.setState({selectedDecision: type, decisionDialogOpen: false}, state => this.handleSaveChangesAndClose());
  }

  makeDecisionAction = () => {
    return [
      <FlatButton
        label="Tallenna & Tee päätös"
        primary={true}
        onTouchTap={this.openDecisionMenu}
        disabled={!this.isValidForm()}
      />
    ];
  }

  notEditedActions() {
    var cancelTitle = this.props.company._id === "" ? "Peruuta" : "Sulje";
    var toRet = [
      <FlatButton
        label={cancelTitle}
        onTouchTap={this.props.handleClose}
      />
    ];

    if (!this.isNew) {
      toRet.push(this.makeDecisionAction());
    }

    return toRet;
  }

  savingActions() {
    return [<CircularProgress size={30} thickness={2} style={{marginRight:'60px'}} />];
  }

  editedActions() {
    var saveTitle = this.state.isNew ? "Luo yritys" : "Tallenna muutokset";
    var saveAndCloseTitle = this.state.isNew ? "Luo yritys ja sulje" : "Tallenna muutokset ja sulje";
    var cancelTitle = this.state.isNew ? "Peruuta" : "Peruuta muutokset";
    var toRet = [
      <FlatButton
        label={cancelTitle}
        onTouchTap={() => this.props.handleClose()}
      />,
      <FlatButton
        label={saveAndCloseTitle}
        primary={true}
        onTouchTap={() => this.handleSaveChangesAndClose()}
        disabled={!this.isValidForm()}
      />,
      <FlatButton
        label={saveTitle}
        primary={true}
        onTouchTap={() => this.handleSaveChanges()}
        disabled={!this.isValidForm()}
      />
    ];

    if (!this.isNew) {
      toRet.push(this.makeDecisionAction());
    }

    return toRet;
  }

  validateCompany() {
    var valid = true;
    var state = this.state;

    if (this.state.company.officialName.length <= 0) {
      valid = false;
      state.editedOfficialNameOnce = true;
    }

    if (!this.state.company.industry) {
      state.categoryErrorText = "Pakollinen tieto. Valitse toimiala pudotusvalikosta";
      valid = false;
    }

    if (!this.state.company.municipality) {
      state.municipalityErrorText = "Pakollinen tieto. valitse alue pudotusvalikosta";
      valid = false;
    }

    this.setState(state);

    return valid;
  }

  handleSaveChangesAndClose() {
    this.saveChanges().then(company => {
        this.setState({ company: company, saving: false, hasUnsavedChanges: false, isNew: false });
        this.props.handleClose();
    });
  }

  handleSaveChanges() {
    this.saveChanges().then(company => {
      this.setState({ company: company, saving: false, hasUnsavedChanges: false, isNew: false});
    });
  }

  saveChanges() {
    return new Promise((resolve, reject) => {
      let valid = this.validateCompany();
      if (valid) {
        this.setState({saving: true, selectedDecision: undefined});
        if (this.state.isNew) {
          CompanyService.createCompany(this.state.company)
          .then(company => resolve(company))
          .catch(error => {
            this.handleErrorSave(error);
            this.setState({ saving: false }, state => reject(error));
          });
        } else {
          CompanyService.editCompany(this.state.company, this.state.selectedDecision)
          .then(company => resolve(company))
          .catch(error => {
            this.handleErrorSave(error);
            this.setState({ saving: false }, state => reject(error));
          });
        }
      }
    });
  }

  handleErrorSave(error) {
    if (error.code == 400) {
      this.setState({nameErrorText: "Tämän niminen yritys on jo olemassa"});
    }
  }

  isValidOfficialName() {
    return this.state.company.officialName.length > 0;
  }

  isValidValue() {
    var value = this.state.company.contractValue;
    return !value || value === "" || Number.isInteger(value) || (value.match(/^[0-9]+$/) && value >= 0);
  }

  hasMunicipality() {
    return this.state.company.municipality != null && this.state.company.municipality != undefined
  }

  isValidForm() {
    return this.isValidOfficialName() && this.isValidValue() && this.hasMunicipality();
  }

  removeLogo() {
    CompanyService.deleteLogo(this.state.company.friendlyId).then(removed => {
      if (removed) {
        var state = this.state;
        state.company.logoName = undefined;
        this.setState(state);
      }
    });
  }

  uploadImage(event) {
    this.setState({fileUploadErrorText:undefined});

    var input = event.target;

    var data = new FormData();
    var file = input.files[0];

    if (!this.isValidFileType(file.name)) {
      this.setState({fileUploadErrorText: "Virheellinen tiedostotyyppi."});
      return;
    }

    if (file.size > 1024000) {
      this.setState({fileUploadErrorText: "Liian iso tiedosto."});
      return;
    }

    data.append('file', file);
    data.append('name', file.name);

    CompanyService.uploadLogo(this.state.company.friendlyId, data).then(logoName => {
      var state = this.state;
      state.company.logoName = logoName;
      this.setState(state);
    }).catch(error => {
      this.setState({fileUploadErrorText: "Virhe kuvan lähetyksessä."});
    });
  }

  isValidFileType(filename) {
     var ext = filename.match(/\.([^\.]+)$/)[1];
     switch(ext)
     {
         case 'jpg':
         case 'JPG':
         case 'png':
         case 'PNG':
         case 'JPEG':
         case 'JPG':
         case 'gif':
         case 'GIF':
             return true;
         default:
            return false;
     }
  }

  onAddNewContact() {
    this.setState({addingNewContact: true});
  }

  onDeleteCompany() {
    this.setState({deleteDialogOpen: true});
  }

  onConfirmDeleteCompany() {
    CompanyService.deleteCompany(this.state.company.friendlyId).then(() => {
      this.setState({ company: this.emptyCompany(), saving: false, hasUnsavedChanges: false, isNew: false });
      this.props.handleClose();
    });
  }

  onContactDelete(row) {
    CompanyService.deleteContact(this.state.company.friendlyId, this.state.company.companyContacts[row]._id).then(updatedCompany => {
      var state = this.state;
      state.company.companyContacts = updatedCompany.companyContacts;
      state.addingNewContact = false;
      this.setState(state);
    });
  }

   renderContactsSection() {
    var contactRows = this.state.company.companyContacts.map(contact => {
      return <ContactRow key={contact._id} contact={contact} onContactDelete={(row) => this.onContactDelete(row)}/>
    });

    var addContactButton = <FlatButton label="Lisää yhteystieto" onTouchTap={() => this.onAddNewContact()}/>;
    var newContactComponent = <ContactNewRow key="new-contact-1234565" onContactSave={(json) => this.onContactSave(json)}/>;

    var addContactButton = this.state.addingNewContact ? '' :  <FlatButton label="Lisää yhteystieto" onTouchTap={() => this.onAddNewContact()}/>;
    var newContactComponent = this.state.addingNewContact ? <ContactNewRow onContactSave={(json) => this.onContactSave(json)}/> : '';

    return this.state.isNew ? '' :
    <div style={{width: "100%"}}>
      <h2>Maksulliset lisäyhteystiedot</h2>
      <Table
        multiselectable={false}>
        <TableHeader
          displaySelectAll={false}
          adjustForCheckbox={false}
          enableSelectAll={false}>
          <TableRow>
            <TableHeaderColumn>Etunimi</TableHeaderColumn>
            <TableHeaderColumn>Sukunimi</TableHeaderColumn>
            <TableHeaderColumn>Titteli</TableHeaderColumn>
            <TableHeaderColumn>Puhelinnumero</TableHeaderColumn>
            <TableHeaderColumn>Sähköpostiosoite</TableHeaderColumn>
            <TableHeaderColumn></TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody displayRowCheckbox={false} stripedRows={false}>
          {contactRows}
          {newContactComponent}
        </TableBody>
      </Table>
      {addContactButton}
    </div>;
  }

  onContactSave(json) {
    console.log("should save " + JSON.stringify(json));
    CompanyService.addContact(this.state.company.friendlyId, json).then(updatedCompany => {
      var state = this.state;
      state.company.companyContacts = updatedCompany.companyContacts;
      state.addingNewContact = false;
      this.setState(state);
    });
  }

  renderUserSelectionField() {
    var userAssignedDateString;
    if (this.state.company.assignedToSeller && this.state.company.assignedToSeller != null) {
      var userAssignedDate = new Date(this.state.company.assignedToSeller);
      userAssignedDateString = "Annettu " + userAssignedDate.getDate() + "." + (userAssignedDate.getMonth()+1) + "." + userAssignedDate.getFullYear() + " klo " + userAssignedDate.getHours() + ":" + userAssignedDate.getSeconds();
    }

    return <UserSelectField
                    floatingLabelText="Myyjä"
                    onUserSelected={this.handleSellerChanged}
                    style={{width:"98%"}}
                    errorText={userAssignedDateString}
                    errorStyle={{color: 'black'}}
                    value={this.state.company.seller ? this.state.company.seller._id : null}/>;
  }

  renderLastDecisionComponent() {
    if (this.state.company.decisionHistory.length > 0) {
      var lastDecision = this.state.company.decisionHistory
              .filter(a => (a.type != undefined))
              .sort((a,b) =>  new Date(b.date) - new Date(a.date))[0];

      if (lastDecision) {
        var date = new Date(lastDecision.date);

        return <div>
          <span style={{color: 'rgba(0, 0, 0, 0.298039)',
            fontFamily: "Roboto, serif",
            fontSize: '11px'}}>Edellinen päätös</span><br/>
          <span style={{fontSize:'14px', color: 'rgba(0, 0, 0, 0.870588)'}}>{lastDecision.type.name} {date.getDate() + "." + (date.getMonth()+1) + "." + date.getFullYear()} <br/>
          {lastDecision.seller ? lastDecision.seller.fullName : ''}</span>
        </div>;
      }
    } else { return null; }
  }

  renderDeleteCompanyButton() {
    return <FlatButton
      label="Poista yritys"
      secondary={true}
      onTouchTap={() => this.onDeleteCompany()}
    />;
  }

  renderOldCategoryDiv() {
    if (this.state.company.mainCategory) {
      return <div>
        <b>Vanha toimiala</b>
        <p>{this.state.company.mainCategory.name}</p>
      </div>
    }
  }

  renderNotPublishedDiv() {
    if (!this.state.company.isPublished) {
      return <div style={{backgroundColor: 'yellow', opacity: '0.5'}}>
        <p style={{padding: '10px'}}>Tämä yritys ei näy palvelussa. Yritys näkyy palvelussa sen jälkeen, kun päätös on tehty.</p>
      </div>
    }
  }

  render() {
    var dialogActions = this.state.hasUnsavedChanges ? this.editedActions() : this.notEditedActions();

    if (this.state.saving) {
      dialogActions = this.savingActions();
    }

    var headTitle = this.state.isNew ? "Uusi yritys" : this.state.company.officialName;
    var officialNameErrorText = (this.isValidOfficialName() || !this.state.editedOfficialNameOnce) ? "" : "Yrityksellä täytyy olla virallinen nimi";

    if (this.state.nameErrorText) {
      officialNameErrorText = this.state.nameErrorText;
    }

    var municipalityItems = BaseService.fetchedData.municipalities.map(municipality => {
      return <MenuItem key={municipality._id} value={municipality.name} primaryText={municipality.officialName} />
    });

    var imageContainer = '';
    var cancelButton = '';
    var uploadImageButton = '';
    var uploadButtonTitle = "Valitse logo";
    if (this.state.company.logoName) {
      imageContainer =  <div style={{width: "100%"}}>
                  <img src={logosUrl + this.state.company.logoName} style={{border: "1px black solid", minWidth: "60px", minHeight: "1px", width:"60px", height: "auto"}}/>
                </div>
      cancelButton = <FlatButton
                  label="Poista logo"
                  style={{marginTop: "10px"}}
                  secondary={true}
                  onTouchTap={() => this.removeLogo()}
                  />

      uploadButtonTitle = "Valitse uusi logo";
    }

    if (!this.state.isNew) {
      uploadImageButton = <div><FlatButton
                    label={uploadButtonTitle}
                    labelPosition="before"
                    containerElement="label"
                    primary={true}
                    >
                    <input type="file"
                      onChange={(event) => this.uploadImage(event)}
                      accept=".jpg,.JPG,.gif,.GIF,.JPEG,.jpeg,.png,.PNG"
                      style={{cursor: 'pointer', position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, width: '100%', opacity: 0}} />
                  </FlatButton>
                  <br/>
                  <span style={{color: 'red'}}>{this.state.fileUploadErrorText}</span>
                  <br/>
                  <span>Hyväksytyt tiedostotyypit: jpg, jpeg, gif, png</span>
                  <br/>
                  <span>Kuvan maksimikoko: 1MB</span>
                </div>;
    }


    var contactsSection = this.renderContactsSection();

    var userSelectionField = (Auth.userData && Auth.userData.isAdmin) ? this.renderUserSelectionField() : null;

    var decisionTypeMenuItems = BaseService.fetchedData.decisionTypes.map(type => {
      return <MenuItem primaryText={type.name} value={type._id} key={type._id} onTouchTap={() => this.makeDecision(type)} />
    });

    var lastDecisionComponent = this.renderLastDecisionComponent();

    var deleteButton = this.state.isNew ? null : this.renderDeleteCompanyButton();

    const deleteActions = [
      <FlatButton
        label="Peruuta"
        onTouchTap={this.handleClose}
        keyboardFocused={true}
      />,
      <FlatButton
        label="Poista tämä yritys lopullisesti"
        secondary={true}
        onTouchTap={() => this.onConfirmDeleteCompany()}
      />,
    ];

    return (
        <Dialog
        title={headTitle}
        actions={dialogActions}
        modal={true}
        open={this.props.enabled}
        autoScrollBodyContent={true}
        contentStyle={{width:'99%', maxWidth: '1100px'}}>
          <div style={{width:'100%', overflow: 'auto'}}>
          {this.renderNotPublishedDiv()}
            <h2>Perustiedot</h2>
            <div style={{width:"33.3%", float:"left"}}>
              <TextField
                floatingLabelText="Virallinen nimi*"
                disabled={!this.state.isNew}
                multiLine={true}
                value={this.state.company.officialName}
                errorText={officialNameErrorText}
                onChange={this.handleOfficialNameEdit}
                style={{width:"98%"}}
                />
              <TextField
                floatingLabelText="Markkinointinimi"
                multiLine={true}
                value={this.state.company.marketingName}
                onChange={(event) => this.handleMarketingNameEdit(event)}
                style={{width:"98%"}}
                />
            </div>
            <div style={{width:"33.3%", float:"left"}}>
              <TextField
                floatingLabelText="Y-Tunnus"
                value={this.state.company.companyId}
                onChange={(event) => this.editValue(event, "companyId")}
                style={{width:"98%"}}
                />
            </div>
            <div style={{width:"33.3%", float:"left"}}>
              <AutoComplete
                  dataSource={BaseService.fetchedData.industries}
                  dataSourceConfig={{text: 'name', value: '_id'}}
                  filter={AutoComplete.caseInsensitiveFilter}
                  floatingLabelText={this.state.company.industry ? this.state.company.industry.name : 'Toimiala*'}
                  listStyle={{width:'100%'}}
                  hintText="Kaikki toimialat"
                  maxSearchResults={10}
                  style={{width:"98%"}}
                  textFieldStyle={{width:"100%"}}
                  errorText={this.state.categoryErrorText}
                  onNewRequest={this.handleIndustryChanged}
                />
              {deleteButton}
            </div>
            {this.renderOldCategoryDiv()}
          </div>

          <div style={{width:'100%', overflow: 'auto'}}>
            <h2>Yhteystiedot</h2>
            <div style={{width:"33.3%", float:"left"}}>
              <TextField
                floatingLabelText="Puhelinnumero"
                value={this.state.company.phoneNumber}
                onChange={(event) => this.editValue(event, "phoneNumber")}
                style={{width:"98%"}}
              />
              <TextField
                floatingLabelText="WWW-osoite"
                value={this.state.company.websiteUrl}
                onChange={(event) => this.editValue(event, "websiteUrl")}
                style={{width:"98%"}}
              />
              <TextField
                floatingLabelText="Sähköpostiosoite"
                value={this.state.company.emailAddress}
                onChange={(event) => this.editValue(event, "emailAddress")}
                style={{width:"98%"}}
              />
            </div>
            <div style={{width:"33.3%", float:"left"}}>
              <AutoComplete
                  dataSource={BaseService.fetchedData.cities}
                  dataSourceConfig={{text: 'name', value: '_id'}}
                  filter={AutoComplete.caseInsensitiveFilter}
                  floatingLabelText={this.state.company.city ? this.state.company.city.name : 'Kaupunki*'}
                  listStyle={{width:'100%'}}
                  hintText="Valitse kaupunki"
                  maxSearchResults={70}
                  menuStyle={{maxHeight: '250px', overflow: 'auto'}}
                  style={{width:"98%"}}
                  textFieldStyle={{width:"100%"}}
                  onNewRequest={this.handleCityChanged}
                />
                <SelectField
                  floatingLabelText="Alue*"
                  onChange={this.handleMunicipalityChanged}
                  value={this.state.company.municipality}
                  style={{width:"98%"}}
                  errorText={this.state.municipalityErrorText}>
                  {municipalityItems}
                </SelectField>
            </div>
            <div style={{width:"33.3%", float:"left"}}>
            <TextField
              floatingLabelText="Osoite"
              multiLine={true}
              value={this.state.company.streetAddress}
              onChange={this.handleStreetAddressEdit}
              style={{width:"98%"}}
              />
            <TextField
              floatingLabelText="Postinumero"
              value={this.state.company.zipCode}
              onChange={(event) => this.editValue(event, "zipCode")}
              style={{width:"98%"}}
              />
            </div>
          </div>


          <div style={{width: '100%', overflow: 'auto'}}>
            <h2>Asiakkuustiedot</h2>
            <div style={{width:"25%", float:"left"}}>
              <TextField
                floatingLabelText="Sopimuksen arvo"
                value={this.state.company.contractValue}
                onChange={(event) => this.handleValueEdit(event)}
                errorText={this.state.valueErrorText}
                style={{width:"98%"}}
                />

              {userSelectionField}
              <TextField
                floatingLabelText="Muistiinpanot"
                multiLine={true}
                value={this.state.company.memo}
                onChange={(event) => this.editValue(event, "memo")}
                style={{width:"98%"}}
              />
            </div>
            <div style={{width:"25%", float:"left"}}>
              {lastDecisionComponent}
              <TextField
                floatingLabelText="Laskutusosoite"
                multiLine={true}
                value={this.state.company.billingAddress}
                onChange={(event) => this.editValue(event, "billingAddress")}
                style={{width:"98%"}}
                />
                <TextField
                  floatingLabelText="Vahvistusosoite"
                  multiLine={true}
                  value={this.state.company.confirmationAddress}
                  onChange={(event) => this.editValue(event, "confirmationAddress")}
                  style={{width:"98%"}}
                  />
            </div>
            <div style={{width:"25%", float:"left"}}>
              <h4>Lisätiedot</h4>
              <Checkbox
                label="Määräaikainen sopimus"
                onCheck={(event, isChecked) => this.editContinuousContract(event, isChecked)}
                checked={!this.state.company.isContinuousContract}
              />
              <Checkbox
                label="Kilpailijaosto, painettu"
                onCheck={(event, isChecked) => this.editBoolValue(event, isChecked, "purchacedByCompetitorPressed")}
                checked={this.state.company.purchacedByCompetitorPressed}
              />
              <Checkbox
                label="Kilpailijaosto (sähköinen)"
                onCheck={(event, isChecked) => this.editBoolValue(event, isChecked, "purchacedByCompetitorDigital")}
                checked={this.state.company.purchacedByCompetitorDigital}
              />
              <Checkbox
                label="Ei Google-profiilia"
                onCheck={(event, isChecked) => this.editBoolValue(event, isChecked, "hasNoGoogleProfile")}
                checked={this.state.company.hasNoGoogleProfile}
              />
              <Checkbox
                label="Ei verkkosivuja"
                onCheck={(event, isChecked) => this.editBoolValue(event, isChecked, "hasNoWebsite")}
                checked={this.state.company.hasNoWebsite}
              />
              <Checkbox
                label="Peruuttanut"
                onCheck={(event, isChecked) => this.editBoolValue(event, isChecked, "hasCancelled")}
                checked={this.state.company.hasCancelled}
              />
              <Checkbox
                label="Poltettu"
                onCheck={(event, isChecked) => this.editBoolValue(event, isChecked, "isBurned")}
                checked={this.state.company.isBurned}
              />
              <Checkbox
                label="Lopettanut"
                onCheck={(event, isChecked) => this.editBoolValue(event, isChecked, "hasFinished")}
                checked={this.state.company.hasFinished}
              />
              <Checkbox
                label="Äffä"
                disabled={this.state.disableIsAffa}
                onCheck={(event, isChecked) => this.editBoolValue(event, isChecked, "isAffa")}
                checked={this.state.company.isAffa}
              />
            </div>
            <div style={{width:"25%", float:"left"}}>
              <h4>Myydyt tuotteet</h4>
              <Checkbox
                label="Alueluettelo"
                onCheck={(event, isChecked) => this.editBoolValue(event, isChecked, "soldAlueluettelo")}
                checked={this.state.company.soldAlueluettelo}
              />
              <Checkbox
                label="Google-profiili"
                onCheck={(event, isChecked) => this.editBoolValue(event, isChecked, "soldGoogleProfile")}
                checked={this.state.company.soldGoogleProfile}
              />
              <Checkbox
                label="Google-profiilin päivitys"
                onCheck={(event, isChecked) => this.editBoolValue(event, isChecked, "soldGoogleProfileUpdate")}
                checked={this.state.company.soldGoogleProfileUpdate}
              />
              <Checkbox
                label="Facebook"
                onCheck={(event, isChecked) => this.editBoolValue(event, isChecked, "soldFacebook")}
                checked={this.state.company.soldFacebook}
              />
              <Checkbox
                label="Ad-Words"
                onCheck={(event, isChecked) => this.editBoolValue(event, isChecked, "soldAdWords")}
                checked={this.state.company.soldAdWords}
              />
              <Checkbox
                label="Kotisivut"
                onCheck={(event, isChecked) => this.editBoolValue(event, isChecked, "soldWebsite")}
                checked={this.state.company.soldWebsite}
              />
            </div>
          </div>
          <div style={{width: '100%', overflow: 'auto'}}>
            <h2>Maksulliset lisätiedot</h2>
            <div style={{width:"33.3%", float:"left"}}>
              <TextField
                floatingLabelText="Aukioloajat"
                multiLine={true}
                value={this.state.company.openingTimes}
                onChange={(event) => this.editValue(event, "openingTimes")}
                style={{width:"98%"}}
                />
              <TextField
                floatingLabelText="Hakusanat"
                multiLine={true}
                value={this.state.company.searchWords}
                onChange={(event) => this.editValue(event, "searchWords")}
                style={{width:"98%"}}
                />
            </div>
            <div style={{width:"33.3%", float:"left"}}>
              <TextField
                floatingLabelText="Lyhyt kuvaus (hakutulos)"
                multiLine={true}
                value={this.state.company.companyDescriptionShort}
                onChange={(event) => this.editValue(event, "companyDescriptionShort")}
                style={{width:"98%"}}
                />
              <TextField
                floatingLabelText="Pitkä kuvaus (yrityksen sivu)"
                multiLine={true}
                value={this.state.company.companyDescription}
                onChange={(event) => this.editValue(event, "companyDescription")}
                style={{width:"98%"}}
                />
            </div>
            <div style={{width:"33.3%", float:"left"}}>
            {imageContainer}
            {cancelButton}
            {uploadImageButton}
            </div>
          </div>
          {contactsSection}
          <Dialog
          modal={true}
          open={this.state.decisionDialogOpen}
          contentStyle={{width:'400px', maxWidth: '400px'}}>
          <Menu style={{width:'100%', maxWidth:'100%'}}>
            {decisionTypeMenuItems}
            <MenuItem primaryText="Peruuta" onTouchTap={() => this.cancelDecisionMenu()}/>
          </Menu>
        </Dialog>
        <Dialog
          modal={true}
          title="Yrityksen poisto"
          actions={deleteActions}
          open={this.state.deleteDialogOpen}>
          Oletko aivan varma, että haluat poistaa tämän yrityksen? Yritys poistuu kannasta lopullisesti!
        </Dialog>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FrontPage/CompanyEditDialog.js